import axiosInstance from "../../../../common/axios/axsiosInstance";
// import { AuthApiEnum } from "./consts";
// const token = getAccessToken();

export function getAccessToken() {
  const data = localStorage.getItem("accessToken");
  const response = data;
  return response;
}
const token = getAccessToken();
export async function singInRequestAdmin(userData, setErrorModalShow) {
  try {
    const response = await axiosInstance.post(
      `admin/login`,
      userData
    );

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    if (error.response && error.response.status === 404) {
      setErrorModalShow({
        message: error.response.data?.message,
      });
    }
    console.error(error);
  }
}

export async function singUpUserRequestAdmin(userData, setErrorModalShow) {
  try {
    const response = await axiosInstance.post(
      `admin/users`,
      userData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    console.log("response-=-=-", response);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    if (error.response && error.response.status === 404) {
      setErrorModalShow({
        message: error.response.data?.message,
      });
    }
    console.error(error);
  }
}

export const getUsersInformationRequest = async () => {
  try {
    const response = await axiosInstance.get(
      `admin/list-users`,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    console.log("-=-=-response-=-=-", response);

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    console.error(error);
  }
};
export async function deleteUserAdmin(userId) {
  try {
    const response = await axiosInstance.delete(
      `admin/users/${userId}`
    );
    if (response.status === 204) {
      return "ok";
    }
  } catch (error) {
    console.error(error);
  }
}

const getErrorMessage = (error) => {
  if (error.response) {
    const status = error.response.status;
    const serverMessage = error.response.data?.message;

    const statusMessages = {
      400: "Please check your input and try again",
      401: "Please log in again",
      403: "You don't have permission for this",
      409: "This already exists",
      422: "Please check your input",
      429: "Too many requests, please wait",
      500: "Server error, please try again",
    };

    return serverMessage || statusMessages[status] || "Something went wrong";
  }

  if (error.request) {
    return "Network error, please check your connection";
  }
  return "An unexpected error occurred";
};

//  toDo avelacnel bolor api-nerum

// toDo avelacnel loderner api colly jamanak

// stugel baiqic ekox infon

// toDo poxel validacian heraxosi hamar ev bolor validacianery
